import Head from "next/head"
import React from "react"
import { t } from "i18next"
import styled from "styled-components"
import { Footer, Header } from "../../components"
import { Privacy } from "../../components/organisms/LandingPage/Privacy"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Content = styled.div`
  max-width: 1480px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 10%;
`

const PrivacyPolicy = () => {
  return (
    <Wrapper>
      <Head>
        <title>Sales Agent | {t("Privacy policy")}</title>
      </Head>
      <Header backgroundColor="#f3f4f6" noButtons />
      <Content>
        <Privacy useTranslation />
        <Privacy />
      </Content>
      <Footer />
    </Wrapper>
  )
}

export default PrivacyPolicy
